import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import CreateWAFList from './CreateWAFList';
import ViewWAFList from './ViewWAFList';
import { SiteTitle } from "../SiteTitle";


function WAFBackground() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="建立WAF追蹤清單" value="1" />
                        <Tab label="查看WAF追蹤清單" value="2" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <CreateWAFList />
                </TabPanel>
                <TabPanel value="2">
                    <ViewWAFList />
                </TabPanel>
            </TabContext>
        </div>
    );
}

export default WAFBackground;
